import { createContext } from 'react';
import type { ReactNode } from 'react';

export const PricingEditionContext = createContext(true);

// The buttons leading to a pricing change are disabled, not hidden, when the
// pricing is frozen (docs/spec/00-project-spec.md §"Optional groups").
export const PricingEditionContextProvider = ({
  children,
  isEditable,
}: Readonly<{ children: ReactNode; isEditable: boolean }>) => (
  <PricingEditionContext.Provider value={isEditable}>
    {children}
  </PricingEditionContext.Provider>
);
